<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-https"/> {{caption}}
        <div class="card-header-actions">
          <CButton color="success" size="sm" @click="exportData()">Exportar a Excel</CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :tableFilter="tableFilter"
        :hover="hover"
        :striped="striped"
        :border="border"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="50"
        :dark="dark"
        pagination
      >
        <template #code="{item}"><td class="text-center w150">{{item.code}}</td></template>
        <template #total="{item}"><td class="text-center w150">{{item.total}}</td></template>
        <template #manager="{item}"><td class="text-center w400">{{item.manager != null ? item.manager : '-'}}</td></template>
      </CDataTable>
    </CCardBody>
  </CCard>
</template>

<script>
import ws from '../../services/suppliers';
import store from '../../store'
import router from '../../router/index'

export default {
  name: 'ActiveSuppliersTable',
  components: { },
  props: {
    items: Array,
    permissions: Object,
    fields: {
      type: Array,
      default () {
        return [
          {key: 'code', label: 'Ruta'},
          {key: 'name', label: 'Nombre'},
          {key: 'manager', label: 'Supervisor'},
          //{key: 'total', label: 'Ventas (3 Meses)'}
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      toasts: [],
      tableFilter: {
        label: 'Buscar: ',
        placeholder: '...'
      }
    }
  },
  methods: {
    async exportData(){
      this.loading();

      let response = await ws.getExcelActives();

      if(response.type == "success"){
        window.location = response.data;
      }
      
      this.loaded();
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    },
    slugify(str) {
      return String(str)
        .normalize('NFKD') // split accented characters into their base characters and diacritical marks
        .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
        .trim() // trim leading or trailing whitespace
        .toLowerCase() // convert to lowercase
        .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
        .replace(/\s+/g, '-') // replace spaces with hyphens
        .replace(/-+/g, '-'); // remove consecutive hyphens
    }
  }
}
</script>
